export function resizeImage(url, width = 210, height = 200) {
    if (url?.startsWith('http')) {
        return `${url}?height=${height}&width=${width}`
    }
    return url;
}
